//NOTES:

//  note 1. Header search input text letter by letter
document.addEventListener("DOMContentLoaded", () => {
  // Select by placeholder text
  const input = document.querySelector('input[placeholder="Search"]');
  if (!input) return;

  // 👇 Note the space at the end of "Search for "
  const base = "Search for ";

  const terms = [
    "motorcycle seats",
    "motorcycle apparels",
    "motorcycle accessories"
  ];

  const typeSpeed = 50;  // ms per character while typing
  const eraseSpeed = 1;  // ms per character while erasing
  const holdMs = 1000;    // pause after a term is fully typed
  const startDelay = 150; // delay after page load before starting

  let stop = false;
  const stopAnim = () => { stop = true; };
  const startAnim = () => { 
    if (!stop) return; 
    stop = false; 
    run(); 
  };

  input.addEventListener("focus", stopAnim);
  input.addEventListener("input", stopAnim);
  input.addEventListener("blur", startAnim);

  const sleep = (ms) => new Promise(r => setTimeout(r, ms));

  async function typeText(text) {
    for (let i = 1; i <= text.length; i++) {
      if (stop) return false;
      input.setAttribute("placeholder", base + text.slice(0, i));
      await sleep(typeSpeed);
    }
    return true;
  }

  async function eraseText(text) {
    for (let i = text.length; i >= 0; i--) {
      if (stop) return false;
      input.setAttribute("placeholder", base + text.slice(0, i));
      await sleep(eraseSpeed);
    }
    return true;
  }

  async function run() {
    await sleep(startDelay);
    while (!stop) {
      for (const term of terms) {
        if (stop) break;
        await typeText(term);
        await sleep(holdMs);
        await eraseText(term);
        await sleep(250);
      }
    }
  }

  // Start animation
  run();
});